import React from "react";
import { Helmet } from "react-helmet-async";

const Seo = ({
  title = "Festival della Scienza 2025",
  description = "Festival della Scienza 2025",
  robots,
  sitename = true,
}) => (
  <Helmet>
    <title>
      {title} {sitename ? " | Festival della Scienza 2025" : ""}
    </title>
    {description && <meta name="description" content={description} />}
    {robots && <meta name="robots" content={robots} />}
  </Helmet>
);

export default Seo;
